import * as React from 'react';
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { Enum, PositionType, isElementOfType } from '../../../library';
import { toasterClasses } from '../index';
import { Toast } from './toast';
export var ToasterPosition = Enum({
  TOP: PositionType.TOP,
  TOP_LEFT: PositionType.TOP_LEFT,
  TOP_RIGHT: PositionType.TOP_RIGHT,
  BOTTOM: PositionType.BOTTOM,
  BOTTOM_LEFT: PositionType.BOTTOM_LEFT,
  BOTTOM_RIGHT: PositionType.BOTTOM_RIGHT
});
export var ToastStack = function ToastStack(props) {
  var classNames = cn(toasterClasses.STACK, "-".concat(props.position), props.className);
  var motionVariants = {
    "in": {
      opacity: 1,
      y: 0,
      height: 'auto',
      zIndex: 1
    },
    outUp: {
      opacity: 0,
      y: -48,
      height: 0,
      zIndex: -1,
      transition: {
        duration: 0.2
      }
    },
    outDown: {
      opacity: 0,
      y: 48,
      height: 0,
      zIndex: -1,
      transition: {
        duration: 0.2
      }
    }
  };
  var intialPosition = ['top', 'top-left', 'top-right'].includes(props.position) ? 'outUp' : 'outDown';
  return React.createElement(motion.div, {
    className: classNames,
    variants: {
      "in": {
        opacity: 1
      },
      outUp: {
        opacity: 0,
        transition: {
          duration: .2
        }
      },
      outDown: {
        opacity: 0,
        transition: {
          duration: .2
        }
      }
    },
    initial: false,
    animate: 'in',
    exit: intialPosition
  }, React.createElement(AnimatePresence, null, React.Children.map(props.children, function (child) {
    if (!isElementOfType(child, Toast)) return null;
    return React.createElement(motion.div, {
      key: child.props.id,
      variants: motionVariants,
      initial: intialPosition,
      animate: 'in',
      exit: intialPosition
    }, child);
  })));
};
ToastStack.displayName = 'ToastStack';
ToastStack.defaultProps = {
  position: PositionType.TOP_LEFT
};